import { useEffect, useState } from 'react'

import IMG_LOGO from 'assets/images/applink/applink_logo.png'
import './AppLinkMain.scss'

/**
 * @file 닷앱 어플리케이션 설치 이동 화면
 */
function AppLinkMain() {
    const [timeoutId, setTimeoutId] = useState(null)
    const timeLimit = 1000 // 타임아웃 시간 (1초로 설정)
    const customScheme = 'dotstationapp://payment'
    const installAndoidUrl = 'https://play.google.com/store/apps/details?id=com.genstation.client'
    const installIOSUrl = 'https://apps.apple.com/kr/app/%EB%8B%B7%EC%8A%A4%ED%85%8C%EC%9D%B4%EC%85%98/id6446716586' //닷스테이션
    //const installIOSUrl = 'https://apps.apple.com/kr/app/%EB%B0%B0%EB%8B%AC%EC%9D%98%EB%AF%BC%EC%A1%B1/id378084485' //배달의민족

    useEffect(() => {
        window.location.href = customScheme

        appOpenTimeOut()
    }, [])

    useEffect(() => {
        //pagehide 함수
        const handlePageHide = () => {
            clearTimeout(timeoutId) // 페이지가 숨겨지면 타임아웃 제거
        }

        //visibilitychange 함수
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                clearTimeout(timeoutId) // 앱이 화면에 보이지 않으면 타임아웃 제거
            }
        }

        // 이벤트 리스너 등록
        window.addEventListener('pagehide', handlePageHide)
        window.addEventListener('visibilitychange', handleVisibilityChange)

        // 컴포넌트 언마운트 시에 이벤트 리스너 제거
        return () => {
            window.removeEventListener('pagehide', handlePageHide)
            window.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [timeoutId])

    //안드로이드 와 iOS 판단 함수
    const detectMobileOS = () => {
        const userAgent = navigator.userAgent.toLowerCase()
        const isAndroid = userAgent.includes('android')
        const isIOS = !isAndroid && /iphone|ipad|ipod|Mac/i.test(userAgent)

        return { isAndroid, isIOS }
    }

    //앱 실행 타임아웃
    const appOpenTimeOut = () => {
        // 새로운 타임아웃 설정
        const newTimeoutId = setTimeout(timeoutFunction, timeLimit)
        setTimeoutId(newTimeoutId)
    }

    // 일정 시간이 지나도록 앱이 열리지 않으면 실패로 처리
    const timeoutFunction = () => {
        const { isAndroid, isIOS } = detectMobileOS()

        if (isAndroid) {
            //window.location.href = installAndoidUrl
            window.open(installAndoidUrl, '_blank')
        } else if (isIOS) {
            window.open(installIOSUrl)
        }
    }

    //앱 실행하기 버튼 선택 시
    const appOpenClick = () => {
        window.location.href = customScheme
        // 이미 타임아웃이 설정되어 있다면 클리어
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        appOpenTimeOut()
    }

    return (
        <>
            <div className="applink-wrapper">
                <div className="applink_wrap">
                    <div className="applink_bg">
                        <div className="applink_center_wrap">
                            <img className="applink_center_logo" src={IMG_LOGO} alt="닷스테이션 로고" />
                            <div className="applink_center_text_wrap">
                                <p className="applink_center_text_one">배터리 교환 서비스에</p>
                                <p className="applink_center_text_two">마침표를 찍다</p>
                            </div>
                        </div>
                        <div className="applink_bototm_wrap">
                            <button className="applink_open" onClick={() => appOpenClick()}>
                                앱 실행하기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AppLinkMain
